import { createVNode as a, mergeProps as n } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileYasuoTwotoneStandard.js";
import i from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return a(i, n(e, {
    icon: s
  }), null);
};
o.displayName = "FileYasuoTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
